// hooks/useThreads.js
import { useState, useEffect, useCallback } from "react";
import { fetchThreadsWithLastMessage, deleteThread as apiDeleteThread } from "../api/api";

export function useThreads(userId) {
  const [threads, setThreads] = useState([]);

  // This refreshes the threads from the backend!
  const refreshThreads = useCallback(async () => {
    if (!userId) return;
    try {
      const data = await fetchThreadsWithLastMessage(userId);
      setThreads(data);
    } catch (err) {
      console.error("fetchThreadsWithLastMessage:", err);
    }
  }, [userId]);

  useEffect(() => {
    refreshThreads();
  }, [refreshThreads]);

  const addThread = useCallback((t) => setThreads((p) => [...p, t]), []);
  const deleteThread = useCallback(async (id) => {
    try {
      await apiDeleteThread(id);
      setThreads((prev) => prev.filter((t) => t.id !== id));
    } catch (err) {
      console.error("deleteThread:", err);
    }
  }, []);

  return { threads, addThread, deleteThread, setThreads, refreshThreads };
}